<template>
  <div class="main">
    <van-nav-bar title="个人信息录入" />
    <van-form @submit="onSubmit" :submit-on-enter="false">
      <van-field input-align="right" v-model="userInfo.name" label="证件姓名" placeholder="请输入证件姓名"
        :rules="[{ validator: rulesName, message: '请输入正确姓名' }]" maxlength="6" />
      <van-field input-align="right" disabled label="证件类型" placeholder="二代身份证" />
      <van-field input-align="right" v-model="userInfo.idcard" label="证件号码" placeholder="请输入证件号码"
        :rules="[{ validator: rulesId, message: '请输入正确证件号码' }]" maxlength="18"/>
      <van-field input-align="right" v-model="userInfo.company" label="单位名称" placeholder="请输入单位名称"
        :rules="[{ required: true, message: '请输入单位名称' }]" maxlength="35" />
      <van-field input-align="right" v-model="userInfo.address" label="现居地址" placeholder="请输入现居地址"
        :rules="[{ required: true, message: '请输入现居地址' }]" maxlength="35" />
      <van-field input-align="right" type="number" v-model="userInfo.bank" label="到账银行卡" placeholder="请输入到账银行卡"
        :rules="[{ required: true, message: '请输入到账银行卡' }]"  maxlength="24" />
      <van-field input-align="right" type="tel" v-model="userInfo.phone" label="手机号码" placeholder="请输入手机号码"
        :rules="[{ validator: rulesIphone, message: '请输入正确手机号码' }]" maxlength="11" />
      <van-button round block type="info" native-type="submit">提交申请</van-button>
    </van-form>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <van-loading color="#0094ff">申请中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {
        name: '',
        idcard: '',
        company: '',
        address: '',
        bank: '',
        phone: '',
        code: ''
      },
      showOverlay: false
    }
  },
  mounted() {
    window.localStorage.setItem('code',  this.GetQueryString('code'));
    this.userInfo.code = this.GetQueryString('code');
  },
  methods: {
    rulesName(val) {
      let res = /^[\u4e00-\u9fa5]+$/;
      return res.test(val);
    },
    rulesId(val) {
      let res = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return res.test(val);
    },
    rulesIphone(val) {
      let res = /^1[3456789]\d{9}$/;
      return res.test(val);
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null)
        context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    onSubmit() {
      this.showOverlay = true
      this.api.loan_one(this.userInfo)
        .then(res => {
          if (res.code == 200) {
            setTimeout(() => {
              this.showOverlay = false
              this.$toast({
                type: 'success',
                message: res.msg || '提交成功',
                onClose: () => {
                  window.localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
                  this.$router.push('/rulestep/setp1')
                }
              })
            }, 1200);
          } else {
            window.localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
            this.showOverlay = false
            this.$toast.fail(res.msg);
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
